import { render, staticRenderFns } from "./ComplaintFollowUpCards.vue?vue&type=template&id=07930b63&"
import script from "./ComplaintFollowUpCards.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollowUpCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports